import { makeAutoObservable, reaction } from "mobx";
import { ServerError } from "../models/serverError";

export default class CommonStore {
    error: ServerError | null = null;
    token: string | null = window.localStorage.getItem('jwt');
    cubeJsToken: string | null = window.localStorage.getItem('cubejwt');
    appLoaded = false;

    constructor() {
        makeAutoObservable(this);

        reaction(
            () => this.token,
            token => {
                if (token) {
                    window.localStorage.setItem('jwt', token)
                } else {
                    window.localStorage.removeItem('jwt')
                }
            }
        );

        reaction(
            () => this.cubeJsToken,
            cubeJsToken => {
                if (cubeJsToken) {
                    window.localStorage.setItem('cubejwt', cubeJsToken)
                } else {
                    window.localStorage.removeItem('cubejwt')
                }
            }
        )
    }

    setServerError = (error: ServerError) => {
        this.error = error;
    }

    setToken = (token: string | null) => {
        this.token = token;
    }

    setCubeJsToken = (cubeJsToken: string) => {
        this.cubeJsToken = cubeJsToken;
    }

    setAppLoaded = () => {
        this.appLoaded = true;
    }
}